import AppHeader from "@/components/AppHeader";
import Footer from "@/components/Footer";
import PricingContent from "@/components/PricingContent";

const Pricing = () => {
  return (
    <div className="min-h-screen bg-background">
      <AppHeader variant="marketing" />
      <main className="pt-28 pb-24">
        <div className="container mx-auto px-4">
          <PricingContent headingAs="h1" />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Pricing;
